import * as React from "react";

import { ActivityType, useXO } from "../../../Common";

import { ReactPlpAnalyticsInterface } from "./analytics-interface";

export const useAnalyticsXO = (): ReactPlpAnalyticsInterface => {
  const { pushToTheDataLayer, consumerInitializationGuard } = useXO();

  const onViewFredhopperListingPage: NonNullable<
    ReactPlpAnalyticsInterface["onViewFredhopperListingPage"]
  > = React.useCallback(
    ({ initialStateSearchTerms, fredhopperResponse }) => {
      let event: ActivityType = {
        action: "view",
        target: {
          page: `${window.location.pathname}${window.location.search}`,
        },
        sourceId: fredhopperResponse.response_id,
      };

      if (
        initialStateSearchTerms &&
        (initialStateSearchTerms?.length || 0) > 0
      ) {
        const eventTargetingSearchTerms = {
          "search-terms": initialStateSearchTerms,
        };
        event.target = {
          ...event.target,
          ...eventTargetingSearchTerms,
        };
      }

      pushToTheDataLayer(event);
    },
    [pushToTheDataLayer]
  );

  const clickActionOnProduct: NonNullable<
    ReactPlpAnalyticsInterface["clickActionOnProduct"]
  > = React.useCallback(
    ({ presentationProduct }) => {
      const event: ActivityType = {
        action: "click",
        target: {
          product: presentationProduct.id,
        },
        sourceId: presentationProduct.fredhopperResponseId,
      };
      pushToTheDataLayer(event);
    },
    [pushToTheDataLayer]
  );

  const clickActionOnProductFromCampaign: NonNullable<
    ReactPlpAnalyticsInterface["clickActionOnProductFromCampaign"]
  > = React.useCallback(
    ({ presentationThemeProduct }) => {
      const event: ActivityType = {
        action: "click",
        target: {
          product: presentationThemeProduct.id,
          campaign: presentationThemeProduct.fredhopperCampaignId,
        },
        sourceId: presentationThemeProduct.fredhopperResponseId,
      };
      pushToTheDataLayer(event);
    },
    [pushToTheDataLayer]
  );

  const clickActionOnFacet: NonNullable<
    ReactPlpAnalyticsInterface["clickActionOnFacet"]
  > = React.useCallback(
    ({ facet, option }) => {
      const event: ActivityType = {
        action: "click",
        target: {
          facet: facet.id,
          [facet.id]: option.id,
        },
        sourceId: facet.fredhopperResponseId,
      };
      pushToTheDataLayer(event);
    },
    [pushToTheDataLayer]
  );

  const initializedInterface: ReactPlpAnalyticsInterface = React.useMemo(
    () => ({
      onViewFredhopperListingPage,
      clickActionOnProduct,
      clickActionOnProductFromCampaign,
      clickActionOnFacet,
    }),
    [
      onViewFredhopperListingPage,
      clickActionOnProduct,
      clickActionOnProductFromCampaign,
      clickActionOnFacet,
    ]
  );
  const analyticsInterface = consumerInitializationGuard({
    initializedInterface,
  });
  return analyticsInterface;
};
